import React from "react"
import { graphql } from "gatsby"

import SEO from "../components/seo"
import Layout from "../components/layout"
import RecommendedPosts from "../components/RecommendedPosts"
import Comments from "../components/Comments"
import * as S from "../components/PostStyle/styled.js"

const Post = ({ data, pageContext }) => {
  const { fields, html, timeToRead } = data.markdownRemark
  const { slug } = fields
  const { title, date, description } = data.markdownRemark.frontmatter
  const next = pageContext.nextPost
  const previous = pageContext.previousPost

  return (
    <Layout>
      <S.Container>
        <SEO title={title} url={slug} description={description} article />
        <S.PostHeader>
          <S.PostDate>
            {date} • {timeToRead} min de leitura
          </S.PostDate>
          <S.PostTitle>{title}</S.PostTitle>
          <S.PostDescription>{description}</S.PostDescription>
        </S.PostHeader>
        <div className="content">
          <S.MainContent>
            <p dangerouslySetInnerHTML={{ __html: html }} />
          </S.MainContent>
        </div>
        <RecommendedPosts next={next} previous={previous} />
        <Comments url={slug} title={title} />
      </S.Container>
    </Layout>
  )
}

export const pageQuery = graphql`
  query PostPage($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      frontmatter {
        title
        date(locale: "pt-br", formatString: "DD [de] MMMM [de] YYYY")
        description
      }
      fields {
        slug
      }
    }
  }
`

export default Post
